<ng-container *ngIf="(breadcrumbItems$ | async) && (breadcrumbItems$ | async).length > 0">
    <div class="container" *ngIf="!(isMobile$ | async) && (showBreadcrumb$ | async)" #breadcrumbContainer>
        <div
            class="business_field_color_draegerblue_bg breadcrumb"
            (mouseleave)="updateExpandStatus(true)"
            (mouseenter)="updateExpandStatus(false)"
            #breadcrumb
        >
            <nav [ngClass]="getCollapsedStatusClass">
                <ol itemscope itemtype="https://schema.org/BreadcrumbList">
                    <ng-container *ngFor="let item of breadcrumbItems$ | async; let $last = last; let $index = index">
                        <ng-container *ngIf="!$last || item.forceLink || $index === 0">
                            <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                                <a da-link itemprop="item" [routerLink]="item.link | localize">
                                    <span itemprop="name">{{ item.label }}</span>
                                </a>
                                <meta itemprop="position" content="{{ $index + 1 }}" />
                            </li>
                            <li *ngIf="$index + 1 === truncateAfter" id="points">...</li>
                        </ng-container>
                        <ng-container *ngIf="$last && $index !== 0 && !item.forceLink">
                            <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                                <span itemscope itemtype="https://schema.org/Thing" itemprop="item" [attr.itemid]="item.link">
                                    <span *ngIf="item.label.length < 66" itemprop="name">{{ item.label }}</span>
                                    <span *ngIf="item.label.length > 65 && shortScreen" itemprop="name">{{ item.label | slice:0:65 }}<span>...</span></span>
                                    <span *ngIf="item.label.length > 85 && middleScreen" itemprop="name">{{ item.label | slice:0:85 }}<span>...</span></span>
                                    <span *ngIf="item.label.length > 120 && bigScreen" itemprop="name">{{ item.label | slice:0:120 }}<span>...</span></span>
                                </span>
                                <meta itemprop="position" content="{{ $index + 1 }}" />
                            </li>
                        </ng-container>
                    </ng-container>
                </ol>
            </nav>
        </div>
    </div>
</ng-container>
